import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
  MoveToTrashBinDocument,
  MoveToTrashBinMutation,
  MoveToTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useMoveToTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const client = useApolloClient()
  const [moveDocumentToTrashBin, { loading }] = useMutation(MoveToTrashBinDocument, {
    extractorFn: (data: MoveToTrashBinMutation) =>
      data.documentsMutations.moveToTrashBinDocumentsDocument,
  })

  return {
    loading,
    async moveDocumentToTrashBin(variables: MoveToTrashBinMutationVariables) {
      const result = await moveDocumentToTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })

      // Fire-and-forget: refetch DataCollection queries in background to avoid
      // blocking the caller (which would cause modal blinking)
      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useMoveToTrashBinDocument
